import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Intelligently merges Tailwind CSS classes.
 * Classes passed later will override conflicting classes passed earlier.
 *
 * @example
 * cn("bg-red-500", "bg-blue-500") // "bg-blue-500"
 * cn("px-2 py-1", className) // className will override px-2 py-1 if there are conflicts
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
